var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_9628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.49996 1.63231C-0.386045 3.59131 -4.48823e-05 5.67231 -4.48823e-05 11.9943C-4.48823e-05 17.2443 -0.916045 22.5073 3.87796 23.7463C5.37496 24.1313 18.639 24.1313 20.134 23.7443C22.13 23.2293 23.754 21.6103 23.976 18.7873C24.007 18.3933 24.007 5.60231 23.975 5.20031C23.739 2.19331 21.888 0.460314 19.449 0.109314C18.89 0.028314 18.778 0.00431397 15.91 -0.000686027C5.73695 0.00431397 3.50696 -0.448686 1.49996 1.63231Z",
    fill: "url(#paint0_linear_178_9628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9981 3.13746C8.36706 3.13746 4.91906 2.81446 3.60206 6.19446C3.05806 7.59046 3.13706 9.40346 3.13706 11.9995C3.13706 14.2775 3.06406 16.4185 3.60206 17.8035C4.91606 21.1855 8.39206 20.8615 11.9961 20.8615C15.4731 20.8615 19.0581 21.2235 20.3911 17.8035C20.9361 16.3935 20.8561 14.6075 20.8561 11.9995C20.8561 8.53746 21.0471 6.30246 19.3681 4.62446C17.6681 2.92446 15.3691 3.13746 11.9941 3.13746H11.9981ZM11.2041 4.73446C18.7781 4.72246 19.7421 3.88046 19.2101 15.5775C19.0211 19.7145 15.8711 19.2605 11.9991 19.2605C4.93906 19.2605 4.73606 19.0585 4.73606 11.9955C4.73606 4.85046 5.29606 4.73846 11.2041 4.73246V4.73446ZM16.7281 6.20546C16.4461 6.20546 16.1758 6.31745 15.9764 6.5168C15.7771 6.71615 15.6651 6.98653 15.6651 7.26846C15.6651 7.55038 15.7771 7.82076 15.9764 8.02011C16.1758 8.21946 16.4461 8.33146 16.7281 8.33146C17.01 8.33146 17.2804 8.21946 17.4797 8.02011C17.6791 7.82076 17.7911 7.55038 17.7911 7.26846C17.7911 6.98653 17.6791 6.71615 17.4797 6.5168C17.2804 6.31745 17.01 6.20546 16.7281 6.20546ZM11.9981 7.44846C11.4005 7.44852 10.8088 7.56629 10.2567 7.79504C9.70463 8.02378 9.20302 8.35902 8.78052 8.78162C7.92723 9.6351 7.44793 10.7926 7.44806 11.9995C7.44819 13.2063 7.92774 14.3637 8.78122 15.217C9.6347 16.0703 10.7922 16.5496 11.9991 16.5495C13.2059 16.5493 14.3633 16.0698 15.2166 15.2163C16.0699 14.3628 16.5492 13.2053 16.5491 11.9985C16.5489 10.7916 16.0694 9.63421 15.2159 8.78092C14.3624 7.92763 13.2049 7.44833 11.9981 7.44846ZM11.9981 9.04546C15.9031 9.04546 15.9081 14.9535 11.9981 14.9535C8.09406 14.9535 8.08806 9.04546 11.9981 9.04546Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_178_9628",
    x1: 1.54598,
    y1: 22.4664,
    x2: 23.8514,
    y2: 3.16129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_9628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.e1794717149570836d6b0fb31d454c31.svg";
export { ForwardRef as ReactComponent };